export class TelefoneIdDataMensagem {
  contato?: string;
  mensagemId?: string;
  data?: Date;
}
